import React from 'react';
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  styled
} from '@mui/material';

export type ButtonProps = Omit<
  MuiButtonProps,
  'size' | 'color' | 'component'
> & {
  size?: 'medium' | 'small' | 'xsmall';
  radius?: 'medium';
  isIcon?: boolean;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  component?: React.ElementType;
};

/**
 * Buttons allow users to take actions, and make choices, with a single tap.
 *
 * This is a custom wrapper component made of Material-UI Button.
 *
 * You can read Material-UI Button Documentation [here](https://mui.com/material-ui/api/Button/).
 *
 * ```typescript
 *  import { Button } from '@rabex-kit/core';
 *  ```
 *
 *
 * @param props
 * @returns
 */

const Button: React.FC<ButtonProps> = styled(MuiButton, {
  name: 'MuiButton',
  shouldForwardProp: prop => prop !== 'isIcon'
})<ButtonProps>(() => ({}));

// const Button: React.FC<ButtonProps> = React.forwardRef(({ ...props }, ref) => {
//   return <MuiButton {...props} ref={ref} />;
// });

Button.defaultProps = {
  variant: 'contained',
  size: 'medium',
  color: 'primary',
  radius: 'medium',
  isIcon: false,
  disableRipple: true,
  disableElevation: true,
  disableFocusRipple: true
};

export default Button;
